import React from 'react';
import ReactTable from 'react-table-6';
import 'react-table-6/react-table.css';
import { connect } from 'react-redux';
import { fetchFrewiePlan } from '../../../../redux/modules/frewie/FrewiePlan';
import { Button } from 'reactstrap';
import { bindActionCreators } from 'redux';
import Page from 'views/components/Page';
import { DEBOUNCE_MILLISECONDS, saveSearchParam, getPage, getPageSize, getFiltered, getSorted } from 'helpers/filterHelper';
import { StorageKeys } from 'constants/storageKeys';
import { ClearFilterButton } from 'views/components/Controls/clear-filter-button/ClearFilterButton';
import { debounce } from '@material-ui/core';

const FILTER_STORAGE_KEY = StorageKeys.ReactTableFilters.FrewiePlanListFilters;

class FrewiePlanList extends React.Component {
  state = {
    loading: false,
  };

  constructor(props) {
    super(props);
    this.defaultSorted = getSorted(FILTER_STORAGE_KEY);
    this.defaultFiltered = getFiltered(FILTER_STORAGE_KEY);
    this.defaultPage = getPage(FILTER_STORAGE_KEY);
    this.defaultPageSize = getPageSize(FILTER_STORAGE_KEY);

    this.fetchData = debounce(this._fetchData, DEBOUNCE_MILLISECONDS);
  }

  search = (pageIndex, pageSize, filtered, sorted) => {
    this.setState({ loading: true });
    this.props
      .fetchFrewiePlan({
        pageIndex: pageIndex,
        pageSize: pageSize,
        filterColumns: filtered,
        sortColumns: sorted,
      })
      .finally(() => {
        this.setState({ loading: false });
        saveSearchParam(FILTER_STORAGE_KEY, pageIndex - 1, pageSize, filtered, sorted);
      });
  };

  _fetchData = (state, instance) => {
    this.search(state.page + 1, state.pageSize, state.filtered, state.sorted);
  }

  render() {
    const { items, pages } = this.props;
    return (
      <Page title="Frewie Plan List" className="PackagePage" breadcrumbs={[{ name: 'Frewie Plan', active: true }]}>
        <div style={{ marginBottom: '1rem' }}>
          <Button
            outline
            color="primary"
            style={{ marginRight: '0.5rem' }}
            onClick={() => this.props.history.push('/setup/frewie-plan-new')}
          >
            New
          </Button>
          <ClearFilterButton
            reactTable={this.reactTable}
          />
        </div>

        <ReactTable
          ref={(r) => this.reactTable = r}
          columns={[
            {
              id: 'planName',
              Header: 'Plan Name',
              accessor: 'planName',
            },
            {
              id: 'description',
              Header: 'Description',
              accessor: 'description',
            },
          ]}
          className="-striped -highlight custom-highlight"
          loading={this.state.loading}
          pageSizeOptions={[5, 10, 20, 25, 50, 100]}
          manual
          filterable
          defaultSorted={this.defaultSorted}
          defaultFiltered={this.defaultFiltered}
          defaultPage={this.defaultPage}
          defaultPageSize={this.defaultPageSize}
          data={items}
          pages={pages}
          onFetchData={this.fetchData}
          noDataText={'No Data...'}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              onClick: () => {
                if (rowInfo && rowInfo.original) {
                  this.props.history.push('/setup/frewie-plan-edit/' + rowInfo.original.id);
                }
              },
            };
          }}
        />
      </Page>
    );
  }
}

const mapStateToProps = ({ frewiePlan }) => ({
  items: frewiePlan.data.items,
  pages: frewiePlan.data.pages,
});

const mapDispatchToProps = dispatch => ({
  fetchFrewiePlan: bindActionCreators(fetchFrewiePlan, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FrewiePlanList);
